import React from 'react'
import { AppContainer, Header } from '@templatean/shared/components'
import AIAssistant from '../components/AIAssistant'

const AIStudioPage: React.FC = () => {
  return (
    <AppContainer>
      <Header 
        title="AI Studio"
        subtitle="Generate and enhance content with AI"
      />
      
      <div className="page-content">
        <AIAssistant />
      </div>
    </AppContainer>
  )
}

export default AIStudioPage